import React from "react";

import Button from "./button";
import Modal from "./modal";
import Modal2 from "./modal2";

interface Props {}

const Footer: React.FC<Props> = () => {
    const simple: any = [
        "/login",
        "/login/",
        // "/signup",
        // "/signup/",
        "/forgot-password",
        "/forgot-password/",
        "/reset-password",
        "/reset-password/",
        "/404",
        "/404/",
        "/unsubscribe",
        "/unsubscribe/",
    ];
    return simple.includes(window.location.pathname) || ["dashboard"].includes(window.location.pathname.split("/")[1]) ? (
        <footer></footer>
    ) : (
        <>
            <footer className="full-footer">
                <div className="container">
                    <div className="row"></div>
                </div>
            </footer>

            <Modal />
            <Modal2 />
        </>
    );
};
export default Footer;
